
export default {
    load(store) {
        // loading goes here
    }
};



// WEBPACK FOOTER //
// ./src/script/controller/example.js